import { render } from "./appTeacherTrain.vue?vue&type=template&id=7a613232&scoped=true"
import script from "./appTeacherTrain.vue?vue&type=script&lang=js"
export * from "./appTeacherTrain.vue?vue&type=script&lang=js"

import "./appTeacherTrain.vue?vue&type=style&index=0&id=7a613232&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a613232"]])

export default __exports__